import React, { Component } from "react";
import { message, PageHeader, Spin, Row, Col, Divider, Tag, Select, Tooltip } from "antd";
import { ArrowLeftOutlined, ArrowUpOutlined, WarningOutlined, FireOutlined, CalculatorOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Form, FormItem, InputNumberItem, SelectItem, DatePickerItem, ButtonItem, ErrorItem, MensajeError, TextAreaItem, SwitchItem } from "../../../../Components/Items";

const { Option } = Select;

class RequerirMaterialOrdenes extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    ordenes: [],
    cantidades: {},
  };

  get ordenesIds() {
    return this.props.location?.state?.ordenesIds || [];
  }

  componentDidMount() {
    if (this.ordenesIds.length < 2) {
      MensajeError({ message: "Selecciona al menos 2 órdenes desde el dashboard de Almacén" });
      return this.props.history.goBack();
    }
    this.consultarDetalles();
  }

  consultarDetalles = async () => {
    this.setState({ loading: true });
    try {
      const respuestas = await Promise.all(
        this.ordenesIds.map((ordenId) =>
          axios.post("almacen/detalleInsumosOrden", { ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
        )
      );

      const ordenes = respuestas
        .filter((res) => res.data.success === 2)
        .map((res) => ({ ...res.data.orden, insumos: (res.data.insumos || []).filter((insumo) => insumo.pendiente > 0) }))
        .filter((orden) => orden.insumos.length > 0);

      if (ordenes.length === 0) {
        message.info("Ninguna de las órdenes seleccionadas tiene material pendiente por requisitar");
      }

      this.setState({ ordenes, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      MensajeError({ message: "Error al conectar con el servidor" });
    }
  };

  onChangeCantidad = (ordenId, insumoId, cantidad) => {
    this.setState((prev) => ({
      cantidades: { ...prev.cantidades, [ordenId]: { ...prev.cantidades[ordenId], [insumoId]: cantidad } },
    }));
  };

  clamp = (valor, orden, insumo) => (orden.tipoLista === "abierta" ? valor : Math.min(valor, insumo.pendiente || 0));

  requerirValorInsumo = (orden, insumo, campo) => this.onChangeCantidad(orden._id, insumo.insumoId, this.clamp(insumo[campo] || 0, orden, insumo));

  requerirTodoDeOrden = (orden, campo) => {
    this.setState((prev) => ({
      cantidades: {
        ...prev.cantidades,
        [orden._id]: Object.fromEntries(orden.insumos.map((insumo) => [insumo.insumoId, this.clamp(insumo[campo] || 0, orden, insumo)])),
      },
    }));
  };

  requerirTodoPendiente = () => {
    const { ordenes } = this.state;
    ordenes.forEach((orden) => this.requerirTodoDeOrden(orden, "pendiente"));
  };

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => {
    const { ordenes, cantidades } = this.state;

    const insumosARequerir = [];
    ordenes.forEach((orden) => {
      orden.insumos.forEach((insumo) => {
        const cantidad = cantidades[orden._id]?.[insumo.insumoId];
        if (cantidad > 0) {
          insumosARequerir.push({ ordenId: orden._id, insumoId: insumo.insumoId, cantidad });
        }
      });
    });

    if (insumosARequerir.length === 0) {
      return message.info("Pon cantidades para poder requerir material");
    }

    this.setState({ loading: true });
    axios
      .post(
        "almacen/requerirMaterialMultiplesOrdenes",
        {
          empresaId: this.props.empresaId,
          insumos: insumosARequerir,
          fechaEntrega: values.fechaEntrega,
          observaciones: values.observaciones,
          importancia: values.importancia,
          separarInsumos: values.separarInsumos,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha generado la requisición número " + res.data.numeroRequisicion);
          this.props.history.goBack();
        } else {
          MensajeError({ message: res.data.error || "No se pudo requerir el material" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    const { ordenes, loading, cantidades } = this.state;

    return (
      <Spin spinning={loading}>
        <PageHeader
          onBack={() => this.props.history.goBack()}
          backIcon={<ArrowLeftOutlined />}
          title={`Requerir material de ${ordenes.length} órdenes`}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={<ButtonItem botonAncho petroleo onClick={this.requerirTodoPendiente}>Requerir todo el pendiente</ButtonItem>}
        />

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <Form
            ref={this.formRef}
            name="RequerirMaterialOrdenes"
            layout
            bottom={
              <ButtonItem mostaza htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Requerir material
              </ButtonItem>
            }
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={8}>
                <FormItem label="Fecha de entrega" name="fechaEntrega" required margin initialValue={moment()}>
                  <DatePickerItem placeholder="Fecha de entrega" allowClear={false} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Importancia" name="importancia" margin initialValue={2}>
                  <SelectItem placeholder="Nivel de importancia">
                    <Option value={1}><Tag color="green"><ArrowUpOutlined /> Baja</Tag></Option>
                    <Option value={2}><Tag color="orange"><WarningOutlined /> Media</Tag></Option>
                    <Option value={3}><Tag color="red"><FireOutlined /> Alta</Tag></Option>
                  </SelectItem>
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Separar insumos" name="separarInsumos" margin initialValue={true} valuePropName="checked">
                  <SwitchItem />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem label="Observaciones" name="observaciones" margin pattern>
                  <TextAreaItem placeholder="Observaciones" />
                </FormItem>
              </Col>
            </Row>

            {ordenes.map((orden) => {
              const esAbierta = orden.tipoLista === "abierta";
              return (
                <div key={orden._id} style={{ marginBottom: 20 }}>
                  <Divider orientation="left" plain>
                    Orden {orden.folio}{" "}
                    <Tag color={esAbierta ? "green" : "default"}>
                      Lista {esAbierta ? "abierta: se puede pedir de más" : "cerrada: tope al pendiente"}
                    </Tag>
                  </Divider>
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="th-border">Insumo</th>
                        <th className="th-border" style={{ width: "12%" }}>Pendiente</th>
                        <th className="th-border" style={{ width: "22%" }}>
                          Cantidad a requerir
                          <Tooltip title="Requerir el faltante (vs. inventario) de todos">
                            <CalculatorOutlined onClick={() => this.requerirTodoDeOrden(orden, "faltante")} style={{ marginLeft: 6, color: "#cf1322" }} />
                          </Tooltip>
                          <Tooltip title="Requerir el pendiente de todos">
                            <CalculatorOutlined onClick={() => this.requerirTodoDeOrden(orden, "pendiente")} style={{ marginLeft: 6, color: "green" }} />
                          </Tooltip>
                          <Tooltip title="Requerir el total necesario de todos">
                            <CalculatorOutlined onClick={() => this.requerirTodoDeOrden(orden, "necesarioTotal")} style={{ marginLeft: 6, color: "#1890ff" }} />
                          </Tooltip>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {orden.insumos.map((insumo) => (
                        <tr key={insumo.insumoId}>
                          <td className="td-border">
                            {insumo.clave ? insumo.clave + " - " : ""}
                            {insumo.descripcion}
                          </td>
                          <td className="td-border">{insumo.pendiente}</td>
                          <td className="td-border">
                            <Row>
                              <Col span={13}>
                                <InputNumberItem
                                  sinBorde
                                  min={0}
                                  max={esAbierta ? undefined : insumo.pendiente}
                                  placeholder={esAbierta ? "Cantidad" : "Max: " + insumo.pendiente}
                                  style={!esAbierta ? { backgroundColor: "#f5f5f5" } : undefined}
                                  value={cantidades[orden._id]?.[insumo.insumoId]}
                                  onChange={(cantidad) => this.onChangeCantidad(orden._id, insumo.insumoId, cantidad)}
                                />
                              </Col>
                              <Col span={11}>
                                <Tooltip title="Requerir el faltante (vs. inventario)">
                                  <CalculatorOutlined onClick={() => this.requerirValorInsumo(orden, insumo, "faltante")} style={{ marginLeft: 5, color: "#cf1322" }} />
                                </Tooltip>
                                <Tooltip title="Requerir el pendiente">
                                  <CalculatorOutlined onClick={() => this.requerirValorInsumo(orden, insumo, "pendiente")} style={{ marginLeft: 5, color: "green" }} />
                                </Tooltip>
                                <Tooltip title="Requerir el total necesario">
                                  <CalculatorOutlined onClick={() => this.requerirValorInsumo(orden, insumo, "necesarioTotal")} style={{ marginLeft: 5, color: "#1890ff" }} />
                                </Tooltip>
                              </Col>
                            </Row>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </Form>
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(RequerirMaterialOrdenes);
